import React, { useState, useEffect, useRef } from "react";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { Chip, IconButton, Typography } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import DeleteIcon from "@mui/icons-material/Delete";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { Tooltip } from "@mui/material";
import { Icon } from "@iconify/react";
import {
  formatWithLeadingZeros,
  is_small_medium_screen,
} from "src/utils/constant";
import { s3baseUrl } from "src/config/config";
import { get_root_value } from "src/utils/domUtils";

const EventCardClient = ({
  workout,
  handleReorder,
  isWorkoutSelected,
  editWorkputData,
  isFirstEventOnDate,
  isLastEventOnDate,
  handleScrollCalled,
  handleCopyExercise,
  handleAgreeDelete,
  setEditWorkputData,
  setEvents,
  events,
  handleUpdateIteration,
  isOpen,
  onToggle,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const timeoutRef = useRef(null);

  let work_out = workout?._def?.extendedProps;

  let extra = work_out?.workout_exercises
    .map((item) => {
      if (item.is_extra) {
        return item;
      }
      return [];
    })
    .flat();

  useEffect(() => {
    return () => {
      clearTimeout(timeoutRef.current);
    };
  }, []);

  const getMinutesForInterval = (mainindex, index) => {
    const list = [...work_out?.workout_exercises];
    const interval = list[mainindex].interval_duration;
    if (interval <= 60) {
      return index + 1;
    }
    if (interval % 60 == 0) {
      return `${
        (interval / 60) * index +
        1 +
        " – " +
        ((interval / 60) * index + interval / 60)
      }`;
    }
    let startInterval = interval * index;
    let endtInterval = interval * index + interval;
    let startintervalText =
      interval * index
        ? Math.floor(startInterval / 60) +
          " " +
          ":" +
          formatWithLeadingZeros(startInterval % 60)
        : 0;
    let endIntervalText =
      Math.floor(endtInterval / 60) +
      " " +
      ":" +
      formatWithLeadingZeros(endtInterval % 60);
    return `${startintervalText + " – " + endIntervalText}`;
  };

  const handleMouseEnter = () => {
    clearTimeout(timeoutRef.current);
    setIsHovered(true);
  };

  const moveEventUp = (eventId) => {
    setEditWorkputData(eventId);
    const changedDateEvents = [...events]
      .filter((event) => event.workout_date === eventId.workout_date)
      .sort((a, b) => a.order - b.order);

    const currentIndex = changedDateEvents.findIndex(
      (event) => event._id === eventId._id,
    );
    if (currentIndex <= 0) return;
    [
      changedDateEvents[currentIndex].order,
      changedDateEvents[currentIndex - 1].order,
    ] = [
      changedDateEvents[currentIndex - 1].order,
      changedDateEvents[currentIndex].order,
    ];

    [
      changedDateEvents[currentIndex].index,
      changedDateEvents[currentIndex - 1].index,
    ] = [
      changedDateEvents[currentIndex - 1].index,
      changedDateEvents[currentIndex].index,
    ];

    const updatedEvents = events.map(
      (event) => changedDateEvents.find((e) => e._id === event._id) || event,
    );

    setEvents(updatedEvents);
    handleReorder(eventId.workout_date, changedDateEvents);

    setTimeout(() => {
      handleScrollCalled(eventId._id);
    }, 0);
  };

  const moveEventDown = (eventId) => {
    setEditWorkputData(eventId);
    const changedDateEvents = [...events]
      .filter((event) => event.workout_date === eventId.workout_date)
      .sort((a, b) => a.order - b.order);

    const currentIndex = changedDateEvents.findIndex(
      (event) => event._id === eventId._id,
    );

    if (currentIndex === -1 || currentIndex >= changedDateEvents.length - 1)
      return;

    [
      changedDateEvents[currentIndex].order,
      changedDateEvents[currentIndex + 1].order,
    ] = [
      changedDateEvents[currentIndex + 1].order,
      changedDateEvents[currentIndex].order,
    ];

    [
      changedDateEvents[currentIndex].index,
      changedDateEvents[currentIndex + 1].index,
    ] = [
      changedDateEvents[currentIndex + 1].index,
      changedDateEvents[currentIndex].index,
    ];

    const updatedEvents = events.map(
      (event) => changedDateEvents.find((e) => e._id === event._id) || event,
    );

    setEvents(updatedEvents);
    handleReorder(eventId.workout_date, changedDateEvents);

    setTimeout(() => {
      handleScrollCalled(eventId._id);
    }, 0);
  };

  const handleMouseLeave = () => {
    const delay = 300;
    timeoutRef.current = setTimeout(() => {
      setIsHovered(false);
    }, delay);
  };

  const complate_workout = (exercise) => {
    return (
      <Tooltip title="Completed">
        <Icon
          icon="fluent-mdl2:completed-solid"
          className="calendar-workout-card-complete-exercises-icon mb-1"
        />
      </Tooltip>
    );
  };

  return (
    <div
      className="calendar-workout-card"
      id={work_out?._id}
      style={{
        boxShadow: isWorkoutSelected(work_out)
          ? "-2px -2px 7px 1px #04abbb, 1px 1px 7px 2px #04abbb"
          : "",
        border:
          editWorkputData?._id == work_out?._id
            ? "2px solid var(--portal-theme-primary)"
            : "0px solid var(--portal-theme-primary)",
        borderTopRightRadius: "7px",
        borderTopLeftRadius: "7px",
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {is_small_medium_screen() ? (
        <div className="w-100 h-100" onMouseEnter={handleMouseEnter}>
          {
            <div className="all-icon-calendar-workout-general-small-screen d-flex w-100 justify-content-between">
              <div className="d-flex">
                <Tooltip
                  title={`${
                    work_out?.is_deleteAble
                      ? "Delete"
                      : "Can't be deleted, This workout has results."
                  }`}
                >
                  <DeleteIcon
                    className={`${
                      work_out?.is_deleteAble
                        ? "del-icon-calendar-workout-general"
                        : "del-icon-calendar-workout-disabled-general"
                    }`}
                    onClick={
                      work_out?.is_deleteAble
                        ? () => handleAgreeDelete(work_out)
                        : () => {}
                    }
                  />
                </Tooltip>
                <Tooltip title={`${"Copy"}`}>
                  <div
                    className={`${"copy-icon-calendar-workout-general ms-1 d-flex justify-content-center align-items-center"}`}
                  >
                    <ContentCopyIcon
                      sx={{ width: 17, height: 17 }}
                      onClick={() => handleCopyExercise(work_out)}
                    />
                  </div>
                </Tooltip>
              </div>
              <div className="d-flex">
                {" "}
                <Tooltip title="Move Up">
                  <div className="arrow-icon-calendar-workout-general ms-1 d-flex justify-content-center align-items-center">
                    <IconButton disabled={isFirstEventOnDate(work_out)}>
                      <KeyboardArrowUpIcon
                        sx={{ width: 17, height: 17 }}
                        onClick={() => moveEventUp(work_out)}
                      />
                    </IconButton>
                  </div>
                </Tooltip>{" "}
                <Tooltip title="Move Down">
                  <div className="arrow-icon-calendar-workout-general ms-1 d-flex justify-content-center align-items-center">
                    <IconButton disabled={isLastEventOnDate(work_out)}>
                      <KeyboardArrowDownIcon
                        sx={{ width: 17, height: 17 }}
                        onClick={() => moveEventDown(work_out)}
                      />
                    </IconButton>
                  </div>
                </Tooltip>{" "}
              </div>
            </div>
          }
        </div>
      ) : (
        <div className="w-100 h-100" onMouseEnter={handleMouseEnter}>
          {isHovered && (
            <div className="all-icon-calendar-workout-general d-flex w-100 justify-content-between">
              <div className="d-flex">
                <Tooltip
                  title={`${
                    work_out?.is_deleteAble
                      ? "Delete"
                      : "Can't be deleted, This workout has results."
                  }`}
                >
                  <DeleteIcon
                    className={`${
                      work_out?.is_deleteAble
                        ? "del-icon-calendar-workout-general"
                        : "del-icon-calendar-workout-disabled-general"
                    }`}
                    onClick={
                      work_out?.is_deleteAble
                        ? () => handleAgreeDelete(work_out)
                        : () => {}
                    }
                  />
                </Tooltip>
                <Tooltip title={`${"Copy"}`}>
                  <div
                    className={`${"copy-icon-calendar-workout-general ms-1 d-flex justify-content-center align-items-center"}`}
                  >
                    <ContentCopyIcon
                      sx={{ width: 17, height: 17 }}
                      onClick={() => handleCopyExercise(work_out)}
                    />
                  </div>
                </Tooltip>
              </div>
              <div className="d-flex">
                <Tooltip title="Move Up">
                  <div className="arrow-icon-calendar-workout-general ms-1 d-flex justify-content-center align-items-center">
                    <IconButton disabled={isFirstEventOnDate(work_out)}>
                      <KeyboardArrowUpIcon
                        sx={{ width: 17, height: 17 }}
                        onClick={() => moveEventUp(work_out)}
                      />
                    </IconButton>
                  </div>
                </Tooltip>{" "}
                <Tooltip title="Move Down">
                  <div className="arrow-icon-calendar-workout-general ms-1 d-flex justify-content-center align-items-center">
                    <IconButton disabled={isLastEventOnDate(work_out)}>
                      <KeyboardArrowDownIcon
                        sx={{ width: 17, height: 17 }}
                        onClick={() => moveEventDown(work_out)}
                      />
                    </IconButton>
                  </div>
                </Tooltip>{" "}
              </div>
            </div>
          )}
        </div>
      )}

      <div onMouseEnter={handleMouseEnter}>
        <div
          className="calendar-workout-card-title"
          style={{
            backgroundColor: work_out?.workout_color,
          }}
          onMouseEnter={handleMouseEnter}
        >
          <div
            className="calendar-workout-card-program d-flex justify-content-between "
            onMouseEnter={handleMouseEnter}
            onClick={() => handleUpdateIteration(work_out)}
          >
            <div onMouseEnter={handleMouseEnter}>
              {work_out?.workout_program?.title}
            </div>
            {work_out?.workout_completed && (
              <div className="">
                <Icon
                  icon="fluent-mdl2:completed-solid"
                  className="workout-complete-icon-container "
                />
              </div>
            )}
          </div>
          <div
            onMouseEnter={handleMouseEnter}
            className="d-flex justify-content-between"
          >
            <div
              className="calendar-workout-card-workout"
              onClick={() => handleUpdateIteration(work_out)}
              onMouseEnter={handleMouseEnter}
            >
              {workout?.title}
            </div>
            <div
              className="d-flex align-items-center"
              onMouseEnter={handleMouseEnter}
            >
              <Icon
                onClick={() => handleUpdateIteration(work_out)}
                icon={
                  work_out?.practice_type == "workout" ||
                  work_out?.library_type == "workout-type"
                    ? "mdi:gym"
                    : work_out?.practice_type == "food" ||
                      work_out?.library_type == "meal-type"
                    ? "fluent:food-24-filled"
                    : work_out?.practice_type == "mindset" ||
                      work_out?.library_type == "mindset-type"
                    ? "flowbite:brain-outline"
                    : work_out?.practice_type == "video"
                    ? "lets-icons:video-fill"
                    : work_out?.practice_type == "comment"
                    ? "mdi:comment-text"
                    : ""
                }
                className="workout-type-icon-container"
              />
              {!isOpen ? (
                <KeyboardArrowDownIcon
                  sx={{
                    cursor: "pointer",
                    opacity: 0.7,
                    fontSize: "20px",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    onToggle(work_out?._id);
                  }}
                />
              ) : (
                <KeyboardArrowUpIcon
                  sx={{
                    cursor: "pointer",
                    opacity: 0.7,
                    fontSize: "20px",
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    onToggle(work_out?._id);
                  }}
                />
              )}
            </div>
          </div>
        </div>
        {isOpen && (
          <div
            onMouseEnter={handleMouseEnter}
            className="calendar-workout-card-exercises"
          >
            <div
              className="calendar-workout-card-container py-1  "
              onClick={() => handleUpdateIteration(work_out)}
              onMouseEnter={handleMouseEnter}
            >
              {work_out?.practice_type === "workbook" && (
                <div
                  className="inner-div workout-calendar-exercise-card my-1"
                  style={{
                    whiteSpace: "break-spaces",
                  }}
                >
                  {work_out?.workout_title}
                </div>
              )}
              {work_out?.practice_type === "video" && (
                <div className="inner-div workout-calendar-exercise-card my-1">
                  {work_out?.dumyImage ? (
                    <div
                      style={{
                        whiteSpace: "break-spaces",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        className="image-border"
                        src={work_out?.dumyImage}
                        height="50"
                      />
                    </div>
                  ) : (
                    <div
                      style={{
                        whiteSpace: "break-spaces",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <img
                        className="image-border"
                        src={s3baseUrl + work_out?.video_thumbnail?.thumbnail_1}
                        height="50"
                      />
                    </div>
                  )}
                </div>
              )}
              {work_out?.practice_type === "comment" && (
                <div
                  className="inner-div workout-calendar-exercise-card my-1"
                  style={{
                    fontSize: "11px",
                    overflow: "hidden",
                    whiteSpace: "break-spaces",
                  }}
                >
                  {work_out?.comment || ""}
                </div>
              )}
              {work_out?.workout_exercises.map((exercise, index) => {
                if (!exercise.is_extra) {
                  if (exercise?.exercise_type == "something_else") {
                    return (
                      <div
                        className="inner-div workout-calendar-exercise-card my-1 "
                        style={{ position: "relative" }}
                      >
                        <div
                          style={{
                            whiteSpace: "break-spaces",
                          }}
                          className="py-1"
                        >
                          {exercise?.is_modified && (
                            <Tooltip
                              title={
                                exercise?.is_modified
                                  ? "Modified"
                                  : "Not Modified"
                              }
                            >
                              <span
                                style={{
                                  display: "block",
                                  position: "absolute",
                                  top: "-5px",
                                  justifyContent: "center",
                                  zIndex: "1",
                                  right: "0px",
                                }}
                              >
                                <Chip
                                  label={"Modified"}
                                  variant="contained"
                                  color={"error"}
                                  sx={{
                                    fontSize: "6px",
                                    height: "auto",
                                    width: "auto",
                                    borderRadius: "3px",
                                    "& .MuiChip-label": {
                                      paddingLeft: "3px",
                                      paddingRight: "3px",
                                    },
                                  }}
                                />
                              </span>
                            </Tooltip>
                          )}
                          {exercise?.is_completed && complate_workout()}
                          {exercise?.title}
                        </div>
                      </div>
                    );
                  } else if (
                    exercise?.exercise_type == "amrap" &&
                    exercise?.emom_amrap &&
                    exercise?.emom_amrap.length > 0
                  ) {
                    return (
                      <div className="workout-calendar-Superset-card inner-div my-1">
                        <div className="text-center">
                          {exercise?.is_completed && complate_workout()}
                          AMRAP
                        </div>
                        {exercise?.emom_amrap?.map((interval) => {
                          return (
                            <div className="my-1">
                              <div style={{ fontSize: "8px" }}>Movements</div>
                              {interval?.map((exerData) => {
                                return (
                                  <div
                                    className="inner-div"
                                    style={{
                                      whiteSpace: "break-spaces",
                                      marginBottom: "3px",
                                    }}
                                  >
                                    {exerData?.exercise_info?.title}
                                  </div>
                                );
                              })}
                            </div>
                          );
                        })}
                      </div>
                    );
                  } else if (
                    exercise?.exercise_type == "rounds_for_time" &&
                    exercise?.emom_amrap &&
                    exercise?.emom_amrap.length > 0
                  ) {
                    return (
                      <div className="workout-calendar-Superset-card inner-div my-1">
                        <div className="text-center">
                          {exercise?.is_completed && complate_workout()}
                          Rounds For Time
                        </div>
                        {exercise?.emom_amrap?.map((interval) => {
                          return (
                            <div className="my-1">
                              <div style={{ fontSize: "8px" }}>Movements</div>
                              {interval?.map((exerData) => {
                                return (
                                  <div
                                    className="inner-div"
                                    style={{
                                      whiteSpace: "break-spaces",
                                      marginBottom: "3px",
                                    }}
                                  >
                                    {exerData?.exercise_info?.title}
                                  </div>
                                );
                              })}
                            </div>
                          );
                        })}
                      </div>
                    );
                  } else if (
                    exercise?.exercise_type == "reps_for_time" &&
                    exercise?.emom_amrap &&
                    exercise?.emom_amrap.length > 0
                  ) {
                    return (
                      <div className="workout-calendar-Superset-card inner-div my-1">
                        <div className="text-center">
                          {exercise?.is_completed && complate_workout()}
                          Reps For Time
                        </div>
                        {exercise?.emom_amrap?.map((interval) => {
                          return (
                            <div className="my-1">
                              <div style={{ fontSize: "8px" }}>Movements</div>
                              {interval?.map((exerData) => {
                                return (
                                  <div
                                    className="inner-div"
                                    style={{
                                      whiteSpace: "break-spaces",
                                      marginBottom: "3px",
                                    }}
                                  >
                                    {exerData?.exercise_info?.title}
                                  </div>
                                );
                              })}
                            </div>
                          );
                        })}
                      </div>
                    );
                  } else if (
                    exercise?.exercise_type == "emom" &&
                    exercise?.emom_amrap &&
                    exercise?.emom_amrap.length > 0
                  ) {
                    return (
                      <div className="workout-calendar-Superset-card inner-div my-1">
                        <div className="text-center">
                          {exercise?.is_completed && complate_workout()}
                          EMOM
                        </div>
                        {exercise?.emom_amrap?.map(
                          (interval, intervalIndex) => {
                            return (
                              <div className="my-1">
                                <div style={{ fontSize: "8px" }}>
                                  Minute{" "}
                                  {getMinutesForInterval(index, intervalIndex)}
                                </div>
                                {interval?.map((exerData) => {
                                  return (
                                    <div
                                      className="inner-div"
                                      style={{
                                        whiteSpace: "break-spaces",
                                        marginBottom: "3px",
                                      }}
                                    >
                                      {exerData?.exercise_info?.title}
                                    </div>
                                  );
                                })}
                              </div>
                            );
                          },
                        )}
                      </div>
                    );
                  } else if (
                    exercise?.sub_exercises &&
                    exercise?.sub_exercises.length > 0
                  ) {
                    return (
                      <div className="workout-calendar-Superset-card inner-div my-1">
                        {exercise?.sub_exercises?.map((exerData, exerIndex) => {
                          return (
                            <div
                              style={{ position: "relative" }}
                              className="my-2"
                            >
                              <div
                                className="inner-div"
                                style={{
                                  whiteSpace: "break-spaces",
                                  marginBottom: "3px",
                                }}
                              >
                                {exerData?.is_modified && (
                                  <Tooltip
                                    title={
                                      exerData?.is_modified
                                        ? "Modified"
                                        : "Not Modified"
                                    }
                                  >
                                    <span
                                      style={{
                                        display: "block",
                                        position: "absolute",
                                        top: "-12px",
                                        justifyContent: "center",
                                        zIndex: "1",
                                        right: "0px",
                                      }}
                                    >
                                      <Chip
                                        label={"Modified"}
                                        variant="contained"
                                        color={"error"}
                                        sx={{
                                          fontSize: "6px",
                                          height: "auto",
                                          width: "auto",
                                          borderRadius: "3px",
                                          "& .MuiChip-label": {
                                            paddingLeft: "3px",
                                            paddingRight: "3px",
                                          },
                                        }}
                                      />
                                    </span>
                                  </Tooltip>
                                )}
                                {exerData?.is_completed && (
                                  <Tooltip
                                    title={
                                      exerData?.is_completed
                                        ? "Completed"
                                        : "Not Completed"
                                    }
                                  >
                                    <Icon
                                      icon="fluent-mdl2:completed-solid"
                                      className="calendar-workout-card-complete-exercises-icon"
                                    />
                                  </Tooltip>
                                )}

                                {exerData?.exercise_info?.title}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    );
                  } else
                    return (
                      <div
                        className="inner-div workout-calendar-exercise-card my-1 "
                        style={{ position: "relative" }}
                      >
                        <div
                          style={{
                            whiteSpace: "break-spaces",
                          }}
                          className="py-1"
                        >
                          {exercise?.is_modified && (
                            <Tooltip
                              title={
                                exercise?.is_modified
                                  ? "Modified"
                                  : "Not Modified"
                              }
                            >
                              <span
                                style={{
                                  display: "block",
                                  position: "absolute",
                                  top: "-5px",
                                  justifyContent: "center",
                                  zIndex: "1",
                                  right: "0px",
                                }}
                              >
                                <Chip
                                  label={"Modified"}
                                  variant="contained"
                                  color={"error"}
                                  sx={{
                                    fontSize: "6px",
                                    height: "auto",
                                    width: "auto",
                                    borderRadius: "3px",
                                    "& .MuiChip-label": {
                                      paddingLeft: "3px",
                                      paddingRight: "3px",
                                    },
                                  }}
                                />
                              </span>
                            </Tooltip>
                          )}
                          {exercise?.is_completed && complate_workout()}
                          {exercise?.exercise_info?.title}
                        </div>
                      </div>
                    );
                }
              })}
              {extra && extra.length > 0 && (
                <div>
                  <div className="text-center">
                    <Typography
                      sx={{
                        color: get_root_value("--portal-theme-primary"),
                        fontWeight: "500",
                      }}
                    >
                      <Icon icon="mdi:bicycle-electric" /> Extra Work
                    </Typography>
                    <div
                      style={{
                        whiteSpace: "break-spaces",
                        fontSize: 10,
                        opacity: 0.8,
                      }}
                    >
                      These exercises aren’t part of the original workout
                    </div>
                  </div>
                  <div>
                    {extra.map((exercise, index) => {
                      if (
                        exercise?.sub_exercises &&
                        exercise?.sub_exercises.length > 0
                      ) {
                        return (
                          <div className="workout-calendar-Superset-card inner-div my-1">
                            {exercise?.sub_exercises?.map((exerData) => {
                              return (
                                <div
                                  style={{
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                  }}
                                >
                                  {exerData?.exercise_info?.title}
                                </div>
                              );
                            })}
                          </div>
                        );
                      } else
                        return (
                          <div className="inner-div workout-calendar-exercise-card my-1">
                            <div
                              style={{
                                whiteSpace: "break-spaces",
                              }}
                            >
                              {exercise?.exercise_info?.title}
                            </div>
                          </div>
                        );
                    })}
                  </div>
                </div>
              )}
              {work_out?.practice_type !== "comment" && (
                <>
                  <div className="mt-2">
                    {work_out?.comment && (
                      <div
                        style={{
                          whiteSpace: "break-spaces",
                          fontSize: 10,
                          opacity: 0.8,
                          fontWeight: "500",
                          color: "black",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 10,
                            opacity: 1,
                            fontWeight: "bold",
                            display: "block",
                            color: get_root_value("--portal-theme-primary"),
                          }}
                        >
                          Comment
                        </span>
                        {work_out?.comment}
                      </div>
                    )}
                  </div>
                  <div className="mt-2">
                    {work_out?.admin_comment && (
                      <div
                        style={{
                          whiteSpace: "break-spaces",
                          fontSize: 10,
                          opacity: 0.8,
                          fontWeight: "500",
                          color: "black",
                        }}
                      >
                        <span
                          style={{
                            fontSize: 10,
                            opacity: 1,
                            fontWeight: "bold",
                            display: "block",
                            color: get_root_value("--portal-theme-primary"),
                          }}
                        >
                          Reply
                        </span>
                        {work_out?.admin_comment}
                      </div>
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default EventCardClient;
